import { Icon, TTextType } from '@ts/storybook';
import Tooltip from './Tooltip';

interface IconTooltipProps {
  name?: string;
  text: TTextType;
  info?: TTextType;
  isHelp?: boolean;
  isInfo?: boolean;
  size?: number;
  color?: string;
  withoutMargin?: boolean;
}

const IconTooltip = ({ isHelp, isInfo, size, color, info, text, withoutMargin, name }: IconTooltipProps) => {
  return (
    <Tooltip title={info ?? text}>
      <Icon
        icon={{ name: name ? name : isInfo ? 'action-info' : isHelp ? 'action-help' : 'action-info', color: color ?? '#bdbdbd' }}
        size={size ?? 20}
        sx={withoutMargin ? {} : { marginLeft: '8px' }}
      />
    </Tooltip>
  );
};

export default IconTooltip;
